import BaseForm from '@kakadu-dev/base-frontend-helpers/forms/BaseForm';
import { wp } from '@kakadu-dev/base-frontend-helpers/helpers/Responsive';
import { DispatchSelector, StateSelector } from "../../modules/selectors"; // const inputContainer = { width: wp(28.125) } // 225

const inputContainer = {
  width: wp(43.438)
}; // 347.5

/**
 * Create order form from terminal
 */

export class CartFormTerminal extends BaseForm {
  constructor(...args) {
    super(...args);
    this.fields = [{
      label: 'Номер телефона',
      name: 'phone',
      props: {
        // common: {
        // 	maskType: BaseForm.MASK_TYPES.PHONE,
        // },
        native: {
          keyboardType: 'phone-pad',
          inputContainer
        }
      }
    }, {
      label: 'E-mail',
      name: 'email',
      props: {
        native: {
          keyboardType: 'email-address',
          inputContainer
        }
      },
      trim: true
    }, // {
    // 	label: 'Промокод',
    // 	name:  'promo',
    // 	props: {
    // 		native: {
    // 			inputContainer,
    // 		},
    // 	},
    // 	trim:  true,
    // },
    {
      label: 'Способ оплаты',
      name: 'paymentMethod',
      type: BaseForm.TYPES.DROPDOWN
    }];
    this.dispatchCreateForm = DispatchSelector.cart.createOrderTerminal;
    this.responseCreateState = StateSelector.cart.createOrderTerminal;
  }

}